import { ActivityType } from './connections';

export enum GaugeUnits {
  METER_PER_HOUR = 'm/h',
  JOINT_PER_HOUR = 'jts/h',
  STAND_PER_HOUR = 'stds/h',
}

export interface OperationBcwWellInformation {
  well_id: string;
  well_name: string;
}

const mockGaugeApiResponse: GaugeApiResponse = {
  gauge_type: ActivityType.DRILLING,
  gauge_min_bound: 0,
  gauge_max_bound: 100,
  gauge_low_area_upper_limit: 20,
  gauge_mid_area_upper_limit: 70,
  operation_avg_value: 50,
  operation_bcw_value: 45,
  operation_current_value: 55,
  operation_bcw_well_information: {
    well_id: 'well123',
    well_name: 'Well 123',
  },
  operation_uom: GaugeUnits.METER_PER_HOUR,
};

export interface GaugeApiResponse {
  gauge_type: ActivityType;
  gauge_min_bound: number | null;
  gauge_max_bound: number | null;
  gauge_low_area_upper_limit: number | null;
  gauge_mid_area_upper_limit: number | null;
  operation_avg_value: number | null;
  operation_bcw_value: number | null;
  operation_current_value: number | null;
  operation_bcw_well_information: OperationBcwWellInformation;
  operation_uom: GaugeUnits;
}
